import React, { useState, useEffect, useRef } from 'react';
import { ReportService } from "../service/ReportService";
import { LanguageService } from "../service/LanguageService";
import { FileService } from '../service/FileService';
import classNames from 'classnames';
import { TagService } from "../service/TagService";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AuthorizationService, MANAGE_REPORTS } from '../service/AuthorizationService';
import './Crud.scss'
import * as _ from 'lodash';
import { ProgressBar } from 'primereact/progressbar';
import { v4 as uuidv4 } from 'uuid';
import { Paginator } from 'primereact/paginator';
import { PickList } from 'primereact/picklist';
import { Dropdown } from 'primereact/dropdown';
import { Fieldset } from 'primereact/fieldset';
import { ToggleButton } from 'primereact/togglebutton'; 
import CronConfig from './cron/CronConfig';
import { InputNumber } from 'primereact/inputnumber';

export function ClientReportCrud(props) {

    const { client } = props;

    let emptyObject = {
        id: uuidv4(),
        name: '',
        description: '',
        powerbi_report_id: '',
        powerbi_group_id: '',
        powerbi_dataset_id: '',
        client_id: client.id,
        config: {}
    };

    const [list, setList] = useState(null);
    const [reportDialog, setReportDialog] = useState(false);
    const [deleteReportDialog, setDeleteReportDialog] = useState(false);
    const [tags, setTags] = useState([]);
    const [report, setReport] = useState(emptyObject);
    const [selectedReports, setSelectedReports] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [hasAccess, setHasAccess] = useState(false);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [modalLoading, setModalLoading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);
    const reportService = new ReportService();
    const tagService = new TagService();
    const authorizationService = new AuthorizationService();
    const languageService = new LanguageService();

    const [pbiWorkspaces, setPbiWorkspaces] = useState([]);
    const [pbiReports, setPbiReports] = useState([]);

    const [searching, setSearching] = useState(false);
    const [search, setSearch] = useState('');
    const [sortField, setSortField] = useState("config->>'order'");
    const [sortOrder, setSortOrder] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [first, setFirst] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const [uploading, setUploading] = useState(false);
    const [thumbnail, setThumbnail] = useState(null);

    const updateList = async () => {
        const data = await reportService.list(first, rowsPerPage, search, sortField, sortOrder);
        setList(data.items);
        setTotalRecords(data.totalRecords);
    }

    const onPageChange = async (pageEvent) => {
        setSearching(true);
        setFirst(pageEvent.first);
        setRowsPerPage(pageEvent.rows);
        const data = await reportService.list(pageEvent.first, pageEvent.rows, search, sortField, sortOrder);
        setList(data.items);
        setTotalRecords(data.totalRecords)
        setSearching(false);
    }

    const doSearch = async (reset) => {
        setSearching(true);
        const data = await reportService.list(first, rowsPerPage, reset ? null : globalFilter, sortField, sortOrder);
        setSearch(globalFilter);
        setList(data.items);
        setTotalRecords(data.totalRecords)
        setSearching(false);
    }

    const onSort = async (sortEvent) => {
        setSearching(true);
        setSortField(sortEvent.sortField);
        setSortOrder(sortEvent.sortOrder);
        const data = await reportService.list(first, rowsPerPage, search, sortEvent.sortField, sortEvent.sortOrder);
        setList(data.items);
        setTotalRecords(data.totalRecords)
        setSearching(false);
    }

    useEffect(() => {
        setHasAccess(authorizationService.hasPermission(MANAGE_REPORTS));

        if(authorizationService.hasPermission(MANAGE_REPORTS)){
            async function fetchData() {
                await updateList();

                const tagsData = await tagService.listAll();
                setTags(tagsData ?? tagsData.items ?? []);
                
                setLoading(false);
            }        
            fetchData();
            
        }
    }, []);

    const saveDisabled = () => {
        return (report.name || "") === "" ||
        (report.description || "") === "";
    }

    const loadPBIData = async (rpt) => {

        await loadPBIWorkspaces();

        if((rpt.powerbi_group_id || "") !== ""){
            await loadPBIReports(rpt.powerbi_group_id);
        }

    }
    const loadPBIWorkspaces = async () => {
        const pbiData = await reportService.listPBIworkspaces(client);
        setPbiWorkspaces((pbiData.value || []).map(v => ({label: v.name, value: v.id})).sort((a,b) => a.label > b.label ? 1 : -1));
    }

    const loadPBIReports = async (workspaceId) => {
        const pbiData = await reportService.listPBIReports(client, workspaceId);
        setPbiReports((pbiData.value || []).map(v => ({label: v.name, value: v.id, datasetId: v.datasetId})).sort((a,b) => a.label > b.label ? 1 : -1));
    }

    const selectPBIWorkspace = async (e) => {
        setModalLoading(true);
        const workspaceId = e.target.value || '';
        let _report = { ...report };
        _.set(_report, 'powerbi_group_id', workspaceId);
        _.set(_report, 'powerbi_report_id', '');
        _.set(_report, 'powerbi_dataset_id', '');
        setReport(_report);
        await loadPBIReports(workspaceId);
        setModalLoading(false);
    }

    const selectPBIReport = async (e) => {
        const reportId = e.target.value || '';
        let _report = { ...report };
        _.set(_report, 'powerbi_report_id', reportId);
        _.set(_report, 'powerbi_dataset_id', pbiReports.find(r => r.value === reportId).datasetId);
        setReport(_report);
    }



    const openNew = async () => {
        try {
            setModalLoading(true);
            emptyObject.id = uuidv4();
            await loadPBIData(emptyObject);
            setReport(emptyObject);
            setSubmitted(false);
            setReportDialog(true);
            setModalLoading(false);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setModalLoading(false);
            console.log(error);
            throw error;
        }
        
        
    }

    const hideDialog = () => {
        if(!saving){
            setSubmitted(false);
            setReportDialog(false);
        }
    }

    const saveReport = async () => {
        try {
            setSaving(true);
            setSubmitted(true);

            if (report.name.trim()) {
                report.client_id = client.id;
                if (report.id) {
                    await reportService.update(report);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Report Updated', life: 3000 });
                }
                else {
                    await reportService.create(report);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Report Created', life: 3000 });
                }

                await updateList();
                setReportDialog(false);
                setReport(emptyObject);
                setSaving(false);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setSaving(false);
            console.log(error);
            throw error;
        }
    }

    const editReport = async (report) => {
        try{
            setModalLoading(true);
            const _report = { ...report };
            if((_report.config.dataset_refresh_cron_expression ?? "") !== "" && (typeof _report.config.dataset_refresh_cron_expression === "string"))
            {
                _report.config.dataset_refresh_cron_expression = [{ id: "1", value: _report.config.dataset_refresh_cron_expression, custom: false }];
            }

            setReport(_report);
            await loadPBIData(report);
            const fileService = new FileService();
            const files = await fileService.listByEntity("report", report.id);
            if(report.config.thumbnail){
                setThumbnail(files.find(f => f.id === report.config.thumbnail));
            }
            
            setReportDialog(true);
            setModalLoading(false);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setModalLoading(false);
            console.log(error);
            throw error;
        }
    }

    const confirmDeleteReport = (report) => {
        setReport(report);
        setDeleteReportDialog(true);
    }

    const deleteReport = async () => {
        try {
            setSaving(true);
            await reportService.delete(report);
            await updateList();
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Report Deleted', life: 3000 });    
        } catch (error) {
            console.log(error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });    
            setSaving(false);
        }

        setDeleteReportDialog(false);
        setReport(emptyObject);
        setSaving(false);
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _report = { ...report };
        
        if(name === "config.dataset_refresh_cron_expression"){
            _report.config.dataset_refresh_cron_expression = e.expression;
            _report.config.next_dataset_refresh = e.next;
        }
        else {
            _.set(_report, name, val);
        }

        setReport(_report);
    }

    const onInputValueChange = (name, val) => {
        let _report = { ...report };
        _.set(_report, name, val);
        setReport(_report);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editReport(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteReport(rowData)} />
            </React.Fragment>
        );
    }

    const uploadFromFile = async (e) => {
        if(e.target.files && e.target.files[0]){
            setSaving(true);
            setUploading(true);
            const reader = new FileReader();
            reader.addEventListener("load", async () => {
                try {
                    const fileService = new FileService();
                    const file = await fileService.upload("report", report.id, "thumbnail", reader.result);
                    const files = await fileService.listByEntity("report", report.id);
                    setThumbnail(files.find(f => f.id === file.id));
                    let _report = { ...report };
                    
                    _.set(_report, 'config.thumbnail', file.id);
                    
                    setReport(_report);
                    setSaving(false);
                    setUploading(false);
                } catch (error) {
                    setSaving(false);
                    setUploading(false);
                    toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });  
                }

                
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const header = (
        <div className="table-header">
            <h5 className="p-m-0">Manage Reports</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => {setGlobalFilter(e.target.value); if(e.target.value === "") doSearch(true);}} placeholder="Search..."  onKeyDown={(e) => { if (e.key === 'Enter') { doSearch()}}}/>
            </span>
        </div>
    );

    const reportDialogFooter = (
        <React.Fragment>
            { !saving && <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />}
            { !saving && <Button disabled={saveDisabled()} label="Save" icon="pi pi-check" className="p-button-text" onClick={saveReport} />}
            { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/>}
        </React.Fragment>
    );

    const deleteReportDialogFooter = (
        <React.Fragment>
            { !saving && <Button label="No" icon="pi pi-times" className="p-button-text" onClick={() => setDeleteReportDialog(false)} />}
            { !saving && <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteReport} />}
            { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/>}
        </React.Fragment>
    );
    
    const powerBIBodyTemplate = (rowData) => {
        return <ul>
                <li><b>Group Id:</b> {rowData.powerbi_group_id}</li>
                <li><b>Report Id:</b> {rowData.powerbi_report_id}</li>
                <li><b>Dataset Id:</b> {rowData.powerbi_dataset_id}</li>
            </ul>;        
    }

    const onChangeTagValues = (e, tagId) => {
        console.log(e, tagId);
        if(!report.values){
            report.values = [];
        }

        report.values = report.values.filter(v => v.tag_id !== tagId).concat(e.target);

        setReport(Object.assign({}, report));
    }

    const reportTypes = [{label: "PowerBI Embed", value: "PBI_EMBED"},{label: "PowerBI Public URL", value: "PBI_PUBLIC"}];

    if(hasAccess){

        return (
            <>
            <div className="datatable-crud-demo">
                <Toast ref={toast} />
                <div className="card">
                    { loading && <ProgressBar mode="indeterminate"/> }
                    { !loading && <Toolbar className="p-mb-4" left={leftToolbarTemplate}></Toolbar>}
                    
                    { !loading &&
                    <>
                    <DataTable ref={dt} value={list} selection={selectedReports} onSelectionChange={(e) => setSelectedReports(e.value)}
                        dataKey="id" rows={rowsPerPage} rowsPerPageOptions={[5, 10, 25]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} reports"
                        header={header}
                        autoLayout={true}
                        onSort={onSort}
                        sortField={sortField} 
                        sortOrder={sortOrder}
                        loading={searching}
                        >

                        <Column field="name" header="Name" sortable></Column>
                        <Column field="report_group" header="Group" sortable></Column>
                        <Column field="type" header="Type" body={(data) => reportTypes.find(rt => rt.value === (data.config.type || 'PBI_EMBED')).label}></Column>
                        <Column field="config.disabled" header={languageService.getText("Ativo")} body={(row) => row.config.disabled ? languageService.getText("No") : languageService.getText("Sim")} style={{textAlign: 'center'}}></Column>
                        <Column field="config->>'order'" sortable header={languageService.getText("Ordenação")} body={(row) => row.config.order ? row.config.order : "-"} style={{textAlign: 'center'}}></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>
                    <Paginator first={first} rows={rowsPerPage} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25, 50, 100]} onPageChange={onPageChange}></Paginator>
                    </>
                    }
                </div>

                <Dialog visible={reportDialog} style={{ width: '90vw' }} header="Report Details" modal className="p-fluid" footer={reportDialogFooter} onHide={hideDialog}>

                    <Fieldset legend="Basic Info">
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col">
                                <label htmlFor="name">Name</label>
                                <InputText disabled={saving} id="name" value={report.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !report.name })} />
                                {submitted && !report.name && <small className="p-invalid">Name is required.</small>}
                            </div>
                            <div className="p-field p-col">
                                <label htmlFor="name">Type</label>
                                <Dropdown disabled={saving} id="type" options={reportTypes} value={report.config.type || "PBI_EMBED"} optionLabel="label" optionValue="value"  onChange={(e) => onInputChange(e, 'config.type')} required className={classNames({ 'p-invalid': submitted && (report.config.type || "") === "" })} />
                                {submitted && !(report.config.type || "") === "" && <small className="p-invalid">Type is required.</small>}
                            </div>
                            <div className="p-field p-col">
                                <label htmlFor="name">Group</label>
                                <InputText disabled={saving} id="name" value={report.report_group} onChange={(e) => onInputChange(e, 'report_group')} />
                            </div>
                        </div>
                        <div className="p-field">
                            <label htmlFor="description">Description</label>
                            <InputTextarea disabled={saving} id="description" value={report.description} onChange={(e) => onInputChange(e, 'description')} required rows={5} cols={20} />
                        </div>
                        <div className="p-field p-col-4">
                                <label htmlFor="name">Ativo</label>
                                <ToggleButton 
                                    checked={!(report.config || {}).disabled} 
                                    onChange={(e) => onInputValueChange('config.disabled', !e.value)}
                                    onLabel={languageService.getText("Yes")}
                                    offLabel={languageService.getText("No")}
                                />
                            </div>
                            <div className="p-field p-col-4">
                                <label htmlFor="order">{languageService.getText("Ordenação")}</label>
                                <InputNumber disabled={saving} id="order" value={report.config.order} onValueChange={(e) => onInputValueChange('config.order', e.value)}/>
                            </div>
                    </Fieldset>

                    <Fieldset legend="PowerBI Info" style={{marginTop: '10px'}}>
                        <div className="p-formgrid p-grid">
                            { (report.config.type || 'PBI_EMBED') === 'PBI_PUBLIC' &&
                                <div className="p-field p-col-12">
                                    <label htmlFor="description">URL</label>
                                    <InputText disabled={saving} id="report_url" value={report.config.pbi_report_url || ""} onChange={(e) => onInputChange(e, 'config.pbi_report_url')} />
                                </div>
                            }
                            { (report.config.type || 'PBI_EMBED') === 'PBI_EMBED' && 
                                <>
                                <div className="p-field p-col-12">
                                    <label htmlFor="groupId">Workspace</label>
                                    <Dropdown disabled={saving} id="groupId" options={pbiWorkspaces} value={report.powerbi_group_id} onChange={(e) => selectPBIWorkspace(e)} required className={classNames({ 'p-invalid': submitted && !report.powerbi_group_id })} />
                                    {submitted && !report.powerbi_group_id && <small className="p-invalid">Group ID is required.</small>}
                                </div>

                                <div className="p-field p-col-12">
                                    <label htmlFor="reportId">Report</label>
                                    { modalLoading && <ProgressSpinner strokeWidth="10" style={{width: '10px', margiLeft: '20px'}}/>}
                                    { !modalLoading && <><Dropdown disabled={saving} id="reportId" options={pbiReports} value={report.powerbi_report_id} onChange={(e) => selectPBIReport(e)} required className={classNames({ 'p-invalid': submitted && !report.powerbi_report_id })} />
                                    {submitted && !report.powerbi_report_id && <small className="p-invalid">Report ID is required.</small>}</>}
                                </div>

                                <div className="p-field p-col-12">
                                    <label htmlFor="description">RLS Role Name</label>
                                    <InputText disabled={saving} id="rls_role_name" value={report.config.pbi_rls_rolename || ""} onChange={(e) => onInputChange(e, 'config.pbi_rls_rolename')} />
                                </div>

                                <div className="p-field p-col-12">
                                    <label htmlFor="reportId">Manage Dataset Refresh</label>:&nbsp;
                                    <ToggleButton checked={report.config.managed_dataset_refresh ? true : false } onChange={(e) => onInputValueChange('config.managed_dataset_refresh', e.target.value)} style={{width: '100px'}} />
                                </div>

                                { report?.config?.managed_dataset_refresh && <CronConfig report={report} onReportUpdated={setReport} /> }

                                <div className="p-field p-col-12">
                                    <label htmlFor="reportId">Show Pages Nagivation</label>:&nbsp;
                                    <ToggleButton checked={report.config.pbi_page_navigation ? true : false } onChange={(e) => onInputValueChange('config.pbi_page_navigation', e.target.value)} style={{width: '100px'}} />
                                </div>
                                </>
                            }
                           
                        </div>
                    </Fieldset>

                    <Fieldset legend={languageService.getText("Vitrine")} style={{marginTop: '10px'}}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-12">
                                <label htmlFor="name">{languageService.getText("Thumbnail")}:&nbsp;&nbsp;&nbsp;</label>
                                <input id="file" type="file" accept="image/*" onChange={uploadFromFile} style={{display: 'none'}}/>
                                <label htmlFor="file" >
                                    {!uploading && <span style={{ cursor: 'pointer'}}><i className="pi pi-fw pi-upload"></i></span> }
                                    {uploading && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/> }
                                </label>
                            </div>
                            { 
                                (report.config.thumbnail || "") !== "" && thumbnail && <>
                                <div className="p-field p-col-12">
                                    <img src={thumbnail.content} style={{maxHeight: '100px', maxWidth: '400px'}}/>
                                </div>
                                <span style={{ cursor: 'pointer'}} onClick={() => {
                                    const _report = { ...report };
                                    _.set(_report, 'config.thumbnail', "") 
                                    } }><i className="pi pi-fw pi-times"></i></span>
                                </>
                            }
                        </div>
                        
            
                    </Fieldset>
                    
                    <Fieldset legend="Visibilidade" style={{marginTop: '10px'}}>
                        { (tags || []).map(tag =>
                            <div className="p-field" key={`tag_${tag.id}`}>
                                <label htmlFor={tag.id}>{tag.name}</label>
                                <PickList 
                                    source={tag.values.filter(v => !(report.values || []).find(va => va.id === v.id))} 
                                    target={(report.values || []).filter(v => v.tag_id === tag.id)} 
                                    itemTemplate={(item) => <div>{item.name}</div>}
                                    onChange={(e) => onChangeTagValues(e, tag.id)} 
                                    sourceHeader="Available" targetHeader="Selected"
                                    showSourceControls={false}
                                    showTargetControls={false}
                                />
                            </div>    
                        )}
                        <div className="p-field p-col-12">
                            <label htmlFor="reportId">Mostrar mesmo sem acesso</label>:<br/>
                            <ToggleButton checked={report.config.show_with_no_access ? true : false } onChange={(e) => onInputValueChange('config.show_with_no_access', e.target.value)} style={{width: '100px'}} />
                        </div>
                    </Fieldset>

                </Dialog>

                <Dialog visible={deleteReportDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteReportDialogFooter} onHide={() => setDeleteReportDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                        {report && <span>Are you sure you want to delete <b>{report.name}</b>?</span>}
                    </div>
                </Dialog>

                

            </div>
            { modalLoading && <div style={{position: 'absolute', top: '0px', width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
                    <ProgressSpinner strokeWidth="5"/>
                </div>
            }
            </>
        );
    }
    else {
        return (
            <div className="datatable-crud-demo">
                <div className="card">
                    <b>Permission Denied</b>
                </div>
            </div>
        );
    }
}